var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Firmware-version" },
    [
      _c("pageTitle", _vm._b({}, "pageTitle", { ..._vm.pT }, false)),
      _c(
        "business-group",
        {
          ref: "businessGroup",
          attrs: {
            tableConfig: { ..._vm.tableConfig },
            formConfig: { ..._vm.formConfig },
          },
          scopedSlots: _vm._u([
            {
              key: "formSlot",
              fn: function (formSlot) {
                return [
                  _c(
                    "a-form-item",
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["title"],
                            expression: "['title']",
                          },
                        ],
                        staticStyle: {
                          width: "520px",
                          "margin-right": "10px",
                          "vertical-align": "middle",
                        },
                        attrs: { placeholder: "请输入灯光名" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["lang"],
                            expression: "['lang']",
                          },
                        ],
                        staticStyle: { width: "150px" },
                        attrs: {
                          placeholder: "请选择语言",
                          "show-search": "",
                          options: _vm.langs,
                          optionFilterProp: "children",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "pic",
              fn: function (record) {
                return [_c("img", { attrs: { width: "100", src: record.pic } })]
              },
            },
            {
              key: "lang",
              fn: function (record) {
                return [
                  _vm._v(" " + _vm._s(_vm.getLangShow(record.lang)) + " "),
                ]
              },
            },
            {
              key: "action",
              fn: function (record) {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(record)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.del(record)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.view(record.id)
                        },
                      },
                    },
                    [_vm._v("添加操作步骤")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "formRight" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-drawer",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
            width: "1200px",
          },
          on: {
            ok: function ($event) {
              return _vm.submitForm("ruleForm")
            },
            close: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: { model: _vm.ruleForm, rules: _vm.rules },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "灯光名", prop: "title" } },
                [
                  _c("a-textarea", {
                    attrs: { placeholder: "请输入灯光名称", maxlength: 64 },
                    model: {
                      value: _vm.ruleForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "title", $$v)
                      },
                      expression: "ruleForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "灯光类型", prop: "lightType" } },
                [
                  _c("a-textarea", {
                    attrs: { placeholder: "请输入灯光类型", maxlength: 64 },
                    model: {
                      value: _vm.ruleForm.lightType,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "lightType", $$v)
                      },
                      expression: "ruleForm.lightType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "色温范围", prop: "temperature" } },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.ruleForm.temperatureMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "temperatureMin", $$v)
                      },
                      expression: "ruleForm.temperatureMin",
                    },
                  }),
                  _vm._v(" K ~ "),
                  _c("a-input-number", {
                    model: {
                      value: _vm.ruleForm.temperatureMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "temperatureMax", $$v)
                      },
                      expression: "ruleForm.temperatureMax",
                    },
                  }),
                  _vm._v(" K "),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "供电方式", prop: "powerSupplyMode" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "供电方式", maxlength: 64 },
                    model: {
                      value: _vm.ruleForm.powerSupplyMode,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "powerSupplyMode", $$v)
                      },
                      expression: "ruleForm.powerSupplyMode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "连接方式", prop: "connectionMode" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "连接方式", maxlength: 64 },
                    model: {
                      value: _vm.ruleForm.connectionMode,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "connectionMode", $$v)
                      },
                      expression: "ruleForm.connectionMode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "购买链接", prop: "purchaseLink" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "购买链接" },
                    model: {
                      value: _vm.ruleForm.purchaseLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "purchaseLink", $$v)
                      },
                      expression: "ruleForm.purchaseLink",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "图片", prop: "pic" } },
                [
                  _c(
                    "a-upload",
                    {
                      staticClass: "m-upload",
                      attrs: {
                        name: "pic",
                        "before-upload": _vm.beforeUpload,
                        remove: _vm.remove,
                        "file-list": _vm.files,
                        disabled: !_vm.nowTitleIsNew,
                      },
                      model: {
                        value: _vm.ruleForm.pic,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "pic", $$v)
                        },
                        expression: "ruleForm.pic",
                      },
                    },
                    [
                      _vm.files.length <= 0
                        ? _c("a-icon", {
                            attrs: { type: _vm.upLoading ? "loading" : "plus" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "语言", prop: "lang" } },
                [
                  _c("a-select", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["lang"],
                        expression: "['lang']",
                      },
                    ],
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: "请选择语言",
                      "show-search": "",
                      options: _vm.langs,
                      optionFilterProp: "children",
                    },
                    model: {
                      value: _vm.ruleForm.lang,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "lang", $$v)
                      },
                      expression: "ruleForm.lang",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "排序字段", prop: "idx" } },
                [
                  _c("a-input-number", {
                    attrs: { placeholder: "排序字段" },
                    model: {
                      value: _vm.ruleForm.idx,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "idx", $$v)
                      },
                      expression: "ruleForm.idx",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              style: {
                position: "absolute",
                bottom: 0,
                width: "100%",
                borderTop: "1px solid #e8e8e8",
                padding: "10px 16px",
                textAlign: "right",
                left: 0,
                background: "#fff",
                borderRadius: "0 0 4px 4px",
              },
            },
            [
              _c(
                "a-button",
                {
                  staticStyle: { "margin-right": "8px" },
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("ruleForm")
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-drawer",
        {
          attrs: {
            visible: _vm.viewVisible,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
            width: "960rpx",
          },
          on: {
            close: function ($event) {
              return _vm.closeView()
            },
          },
        },
        [
          _c(
            "a-descriptions",
            { attrs: { bordered: "" } },
            [
              _c("a-descriptions-item", { attrs: { label: "灯光名" } }, [
                _vm._v(_vm._s(_vm.ruleForm.title)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "灯光类型" } }, [
                _vm._v(_vm._s(_vm.ruleForm.lightType)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "色温范围" } }, [
                _vm._v(
                  _vm._s(_vm.ruleForm.temperatureMin) +
                    "K ~ " +
                    _vm._s(_vm.ruleForm.temperatureMax) +
                    "K"
                ),
              ]),
              _c("a-descriptions-item", { attrs: { label: "供电方式" } }, [
                _vm._v(_vm._s(_vm.ruleForm.powerSupplyMode)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "连接方式" } }, [
                _vm._v(_vm._s(_vm.ruleForm.connectionMode)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "购买链接" } }, [
                _vm._v(_vm._s(_vm.ruleForm.purchaseLink)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "图片" } }, [
                _c("img", { attrs: { src: _vm.ruleForm.pic, width: "100" } }),
              ]),
              _c("a-descriptions-item", { attrs: { label: "语言" } }, [
                _vm._v(_vm._s(_vm.ruleForm.lang)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "排序字段" } }, [
                _vm._v(_vm._s(_vm.ruleForm.idx)),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "addStep" },
            [
              _c("p", { staticClass: "step" }, [_vm._v("设备连接指引步骤：")]),
              _c(
                "a-button",
                {
                  staticClass: "btn_add",
                  on: {
                    click: function ($event) {
                      return _vm.openAddView(
                        _vm.ruleForm.id,
                        _vm.ruleForm.steps?.length || 0
                      )
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      width: "20px",
                      src: require("../../../static/images/plus.png"),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "a-collapse",
            _vm._l(_vm.ruleForm.steps, function (item, index) {
              return _c(
                "a-collapse-panel",
                {
                  key: index,
                  attrs: { header: index + 1 + ". " + item.title },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "extra",
                        fn: function () {
                          return [
                            _c(
                              "a-button",
                              {
                                staticClass: "btn_del",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteStep(item.id)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../static/images/delete.png"),
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "btn_add",
                      on: {
                        click: function ($event) {
                          return _vm.openAddDetailView(item)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "20px",
                          src: require("../../../static/images/plus.png"),
                        },
                      }),
                    ]
                  ),
                  _vm._l(item.details, function (step, idx) {
                    return _c(
                      "p",
                      { key: idx },
                      [
                        _vm._v(_vm._s(idx + 1 + ". " + step.detail) + " "),
                        _c(
                          "a-button",
                          {
                            staticClass: "btn_del",
                            on: {
                              click: function ($event) {
                                return _vm.deleteDetail(step.id)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/images/delete.png"),
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.addVisiable,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
            width: "1000px",
          },
          on: {
            ok: function ($event) {
              return _vm.addStep()
            },
            cancel: function ($event) {
              return _vm.closeView("addVisiable")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: { model: _vm.addStepForm, rules: _vm.addStepRules },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "步骤名：" } },
                [
                  _c("a-textarea", {
                    attrs: { placeholder: "请输入步骤名", maxlength: 1024 },
                    model: {
                      value: _vm.addStepForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.addStepForm, "title", $$v)
                      },
                      expression: "addStepForm.title",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.addDetailVisiable,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
            width: "1000px",
          },
          on: {
            ok: function ($event) {
              return _vm.addStepDetail()
            },
            cancel: function ($event) {
              return _vm.closeView("addDetailVisiable")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: { model: _vm.addStepDetailForm },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "步骤详情：" } },
                [
                  _c("a-textarea", {
                    attrs: { placeholder: "请输入步骤详情", maxlength: 1024 },
                    model: {
                      value: _vm.addStepDetailForm.detail,
                      callback: function ($$v) {
                        _vm.$set(_vm.addStepDetailForm, "detail", $$v)
                      },
                      expression: "addStepDetailForm.detail",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }